import Default from "@/Layouts/Default";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import { Link, animateScroll as scroll } from "react-scroll";

export default function Jobs() {
    return (
        <Default>
            <Head>
                <title>Werken bij</title>
                <link rel="canonical" href={route("work-at")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE is altijd op zoek naar nieuwe trainers om hun klanten te voorzien van de juiste kennis en begeleiding bij het sporten. Kom jij ons team versterken?"
                />
                <meta
                    property="og:description"
                    content="WE ARE is altijd op zoek naar nieuwe trainers om hun klanten te voorzien van de juiste kennis en begeleiding bij het sporten. Kom jij ons team versterken?"
                />
                <meta property="og:url" content={route("work-at")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Werken bij - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                <Hero>
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-7xl">
                        Werken bij
                    </h1>
                    <div className="text-center pt-16">
                        <Link
                            to="requirements"
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="mt-12 uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Meer informatie
                        </Link>
                    </div>
                </Hero>

                <div
                    className="relative xs:p-8 sm:p-8 md:p-16 lg:p-32"
                    id="requirements"
                >
                    <div className="max-w-5xl mx-auto">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            <span className="text-we-are-yellow">We </span>
                            <span className="text-we-are-purple">Are </span>
                            your new job
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Een greep uit deelnemers die met behulp van ons een
                            ware transformatie zijn ondergaan. Ook voor jou is
                            dit mogelijk, wij kunnen je helpen om op zowel
                            fysiek- als mentaal gebied een nieuwe jij te
                            creëren.
                        </p>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            <span className="text-we-are-yellow">We </span>
                            <span className="text-we-are-purple">Are </span>
                            your education
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Als trainer binnen WE ARE krijgt jij een interne
                            opleiding om tot de betere trainers van Nederland te
                            gaan behoren. Tijdens deze interne opleiding leer
                            jij alles wat je dient te weten om onze leden te
                            helpen. De WE ARE ACADEMY bestaat uit een
                            theoretisch,- en praktijkgedeelte. Elk kwartaal ga
                            je samen met jou collega’s deze informatie weer
                            opfrissen en bijscholen om de beste in het vak te
                            blijven. De belangrijke onderwerpen die we bespreken
                            tijdens deze interne opleiding zijn de volgende:
                        </p>
                        <ul className="list-decimal">
                            <li className="mt-5 text-xl text-gray-100">
                                Voeding
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Training
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Mentale weerbaarheid
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Coaching in lifestyle
                            </li>
                        </ul>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            <span className="text-we-are-yellow">We </span>
                            <span className="text-we-are-purple">Are </span>
                            your grow
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Binnen WE ARE vinden we niet alleen de persoonlijke
                            ontwikkeling van onze leden belangrijk maar ook die
                            van onze trainers. Als trainer binnen WE ARE heb je
                            de mogelijkheid om jezelf te ontwikkelen. Elke
                            kwartaal worden er groeigesprekken gehouden om te
                            kijken waar je jezelf nog in kan verbeteren en waar
                            jij graag in wilt groeien. Buiten jouw persoonlijke
                            groei hebben we binnen WE ARE de mogelijkheid om
                            intern te kunnen groeien. Als beginnende trainers
                            kan je jezelf naarmate de jaren, ervaring en
                            resultaten opwerken tot hogere functies binnen de
                            organisatie.
                        </p>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            <span className="text-we-are-yellow">We </span>
                            <span className="text-we-are-purple">Are </span>
                            looking for this
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Wanneer jij grotendeels voldoet aan de volgende
                            eisen kom je in aanraking om trainer binnen WE ARE
                            te kunnen worden:
                        </p>
                        <ul className="list-disc">
                            <li className="mt-5 text-xl text-gray-100">
                                Geen 9 tot 5 mentaliteit hebben
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Bereid zijn om jouw leden te woord te staan
                                wanneer ze hulp nodig hebben
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Ervaring met het helpen / begeleiden van mensen
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Ambitie om jezelf te ontwikkelen
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Het leuk vinden om in een klein team te werken
                                vol met enthousiaste trainers
                            </li>
                        </ul>
                    </div>

                    <div className="max-w-5xl mx-auto mt-12">
                        <h2 className="xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white">
                            <span className="text-we-are-yellow">We </span>
                            <span className="text-we-are-purple">Are </span>
                            offering you this
                        </h2>
                        <p className="mt-5 text-xl text-gray-100">
                            Het aanbod moet altijd vanuit twee kanten komen en
                            dus zijn wij bereid om in jou te investeren als
                            trainer binnen WE ARE. Wanneer je trainer wordt
                            binnen WE ARE hebben we jou het volgende te bieden:
                        </p>
                        <ul className="list-disc">
                            <li className="mt-5 text-xl text-gray-100">
                                Een leuk en gedreven team
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Vier keer per jaar een groeigesprek voor jou
                                eigen ontwikkeling
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Gemotiveerde leden die graag geholpen willen
                                worden
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een sportieve en gemotiveerde werkomgeving
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een telefoon van de zaak om werk en privé
                                gescheiden te houden
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Interne opleiding om jou tot de betere trainers
                                van Nederland te laten behoren
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Een goed loon waarmee jij jouw huisje, boompje,
                                beestje mee kan realiseren
                            </li>
                            <li className="mt-5 text-xl text-gray-100">
                                Interne groei mogelijkheden binnen de
                                organisatie
                            </li>
                        </ul>
                        <a
                            href="mailto:info@we-are.club?subject=Open sollicitatie"
                            className="inline-flex uppercase mt-6 items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-black hover:text-white bg-we-are-yellow hover:bg-we-are-purple"
                        >
                            Stuur open sollicitatie
                        </a>
                    </div>
                </div>

                <Contact />
            </div>
        </Default>
    );
}
